// @flow

import { type File, type FileContentType } from '../File/FileType';

export type FieldRestriction = {
  choices?: Array<string>,
  max?: number,
  min?: number,
  multiple?: boolean,
  pattern?: string,
  schema?: string
};

export type SingleFieldValue = File | string | number | boolean | Object;

export type ListFieldValue = Array<SingleFieldValue>;

export type FieldValue = SingleFieldValue | ListFieldValue;

export const TYPE = {
  ARRAY: 'array',
  BOOL: 'bool',
  BOOLEAN: 'boolean',
  CHOICE: 'choice',
  DATE: 'date',
  DATETIME: 'datetime',
  EMAIL: 'email',
  FILE: 'file',
  FLOAT: 'float',
  INT: 'int',
  LATLONG: 'latlong',
  JSON: 'json',
  MANY: 'many',
  NUMBER: 'number',
  OBJECT: 'object',
  PHOTO: 'photo',
  STRING: 'string',
  TABLE: 'table'
};

export type FieldType =
  | typeof TYPE.ARRAY
  | typeof TYPE.BOOL
  | typeof TYPE.BOOLEAN
  | typeof TYPE.CHOICE
  | typeof TYPE.DATE
  | typeof TYPE.DATETIME
  | typeof TYPE.FILE
  | typeof TYPE.FLOAT
  | typeof TYPE.INT
  | typeof TYPE.LATLONG
  | typeof TYPE.JSON
  | typeof TYPE.MANY
  | typeof TYPE.NUMBER
  | typeof TYPE.OBJECT
  | typeof TYPE.STRING
  | typeof TYPE.TABLE
  | string;

export const isFileType = (fieldType: FieldType) =>
  fieldType === TYPE.FILE || fieldType === TYPE.PHOTO;

export const isLiteralType = (fieldType: FieldType) =>
  fieldType === TYPE.BOOLEAN ||
  fieldType === TYPE.NUMBER ||
  fieldType === TYPE.STRING;

export type Field = {
  accessRestricted?: boolean,
  cipherText?: string,
  conditionCode?: string,
  contentType?: FileContentType,
  createdBy?: string,
  createdDate?: string,
  description?: string,
  displayName?: string,
  displayOnly?: boolean,
  encryptionKeyID?: string,
  example?: string,
  fieldID?: string,
  fieldName?: string,
  hints?: string,
  intent?: string,
  isCreatedByApp?: boolean,
  isRequired?: boolean,
  isSensitive?: boolean,
  items?: boolean,
  nextVersion?: string,
  path?: string,
  predictedBy?: string,
  previousVersion?: string,
  processID?: string,
  processName?: string,
  restrictions?: FieldRestriction,
  runID?: string,
  tableID?: string,
  teamName?: string,
  type: FieldType,
  userID?: string,
  value?: ?FieldValue,
  visibility?: string,
  visibleToUsers?: Array<string>
};

export type FieldValueMap = { [fieldName: string]: FieldValue };

export type FieldWritableFields = Array<string>;

export type FieldContext = {
  runID: string,
  writableFields?: FieldWritableFields
};

export const createEmptyField = (): Field =>
  ({
    type: TYPE.STRING
  }: Field);



// WEBPACK FOOTER //
// ./js/Field/FieldType.js